import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommissionService {
  constructor(private http: HttpClient) {}

  private baseUrl = environment.API_URL + '/admin/commission';

  getCommissionDetails() {
    const url = `${this.baseUrl}/getall`;
    return this.http.get<any>(url).pipe();
  }

  saveCommissionDetails(payload: any) {
    const url = `${this.baseUrl}/save`;
    return this.http.post<any>(url, payload).pipe();
  }

  updateCommissionDetails(payload: any) {
    const url = `${this.baseUrl}/updatestatus`;
    return this.http.post<any>(url, payload).pipe();
  }

  getCommissionByOrderId(orderId: string) {
    const url = `${this.baseUrl}/getbyorder/${orderId}`;
    return this.http.get<any>(url).pipe();
  }

  getCommissionRemarks(commissionId: string) {
    const url = `${this.baseUrl}/getremarks/${commissionId}`;
    return this.http.get<any>(url).pipe();
  }
}
